import { Users, Video } from 'lucide-react'
import type { MeetingContext } from '@/lib/types'

interface Props {
  meeting: MeetingContext
  inZoom: boolean
}

export function MeetingContextBar({ meeting, inZoom }: Props) {
  const title = meeting.title?.trim() || (inZoom ? 'Untitled meeting' : 'No meeting bound')
  const participants = meeting.participants ?? []

  return (
    <div className="border-b border-zinc-200 bg-white px-3 py-2 text-xs">
      <div className="flex items-center gap-1.5 font-medium text-zinc-900">
        <Video className="h-3.5 w-3.5 text-zinc-500" />
        <span className="truncate">{title}</span>
      </div>
      {participants.length > 0 && (
        <div className="mt-1 flex items-start gap-1.5 text-zinc-600">
          <Users className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-zinc-400" />
          <div className="flex flex-wrap gap-1">
            {participants.map((p) => (
              <span
                key={p}
                className="rounded bg-zinc-100 px-1.5 py-0.5 text-[11px] text-zinc-700"
              >
                {p}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
